<!-- Wrapper-->
<div id="app" class="app app-full-height app-without-header">
    <!-- View/routes wrapper-->
    <router-outlet></router-outlet>
    
    <!-- Branding message for login -->
    <a href="https://www.indicium.cloud/indicium-platform" target="_blank" class="powered-by-message">Powered by the INDICIUM Stack</a>
</div>